/* 公共路由 */
const layoutComponent = () => import('@/views/layout')

export default [
  {
    path: '/login',
    name: 'login',
    isOnlyOneLevel: false, // 是否是一级目录，如果是则以当前的路由为目录链接，并且必须有一个path为''的子路由
    component: () => import('@/views/login'),
    meta: {
      title: '登录', // 设置该路由在侧边栏和面包屑中展示的名字
      icon: 'el-icon-menu', // 设置该路由的图标
      breadcrumb: false // 如果设置为false，则不会在breadcrumb面包屑中显示
    }
  },
  {
    path: '/pdfpreview',
    name: 'pdfpreview',
    isOnlyOneLevel: false, // 是否是一级目录，如果是则以当前的路由为目录链接，并且必须有一个path为''的子路由
    component: () => import('@/views/pdfpreview'),
    meta: {
      title: 'pdf预览', // 设置该路由在侧边栏和面包屑中展示的名字
      icon: 'el-icon-menu', // 设置该路由的图标
      breadcrumb: false // 如果设置为false，则不会在breadcrumb面包屑中显示
    }
  },
  {
    path: '/previewfortemplate',
    name: 'previewfortemplate',
    isOnlyOneLevel: false, // 是否是一级目录，如果是则以当前的路由为目录链接，并且必须有一个path为''的子路由
    component: () => import('@/views/pdfpreview/previewfortemplate'),
    meta: {
      title: 'pdf预览', // 设置该路由在侧边栏和面包屑中展示的名字
      icon: 'el-icon-menu', // 设置该路由的图标
      breadcrumb: false // 如果设置为false，则不会在breadcrumb面包屑中显示
    }
  },
  {
    path: '/loginDialog',
    name: 'loginDialog',
    component: () => import('@/views/login/loginDialog.vue'),
    meta: {
      title: '登录', 
      icon: 'el-icon-menu', 
      breadcrumb: false 
    }
  },
  {
    path: '/error',
    name: 'error',
    component: layoutComponent,
    meta: {
      title: '错误页',
      icon: 'el-icon-menu',
      breadcrumb: true
    },
    children: [
      // {
      //   path: '404',
      //   name: '404',
      //   component: () => import('@/views/About.vue'),
      //   // hidden: false,
      //   // alwaysShow: false,
      //   meta: {
      //     title: '404',
      //     icon: 'el-icon-document',
      //     breadcrumb: false
      //   }
      // }
    ]
  },
  {
    path: '/',
    name: 'layout',
    component: layoutComponent,
    meta: {
      title: 'menu.home',
      icon: 'el-icon-ali-shouye',
      breadcrumb: true
    },
    children: [
      // {
      //   path: '',
      //   name: 'defaultChildPage',
      //   component: () => import('@/views/layout/defaultChildPage.vue'),
      //   // hidden: false,
      //   // alwaysShow: false,
      //   meta: {
      //     title: '首页',
      //     icon: 'el-icon-ali-shouye',
      //     breadcrumb: false
      //   }
      // }
    ]
  },
  {
    path: '/account',
    name: 'account',
    component: layoutComponent,
    meta: {
      title: '账户管理',
      icon: 'el-icon-menu',
      breadcrumb: true
    },
    children: [
      // {
      //   path: '/account/changepassword',
      //   name: 'changepassword',
      //   component: () => import('@/views/account/changepassword'),
      //   meta: {
      //     title: '修改密码',
      //     icon: 'el-icon-document',
      //     breadcrumb: true
      //   }
      // }
    ]
  },
  {
    path: '/stationNews',
    name: 'stationNews',
    component: layoutComponent,
    meta: {
      title: '',
      icon: 'el-icon-document',
      breadcrumb: true
    },
    children: [
      {
        path: '/stationNews/stationNewsIndex',
        name: 'stationNewsIndex',
        component: () => import('@/views/stationNews/stationNewsIndex'),
        meta: {
          title: 'menu.stationNews'
        }
      },
      {
        path: '/stationNews/stationNewsDetails',
        name: 'stationNewsDetails',
        component: () => import('@/views/stationNews/stationNewsDetails.vue'),
        meta: {
          title: 'menu.stationNewsDetails',
          routeNameParent: 'stationNewsIndex'
        }
      }
    ]
  },
  {
    path: '/changePassword',
    name: 'changePassword11',
    component: layoutComponent,
    meta: {
      title: '',
      icon: 'el-icon-document',
      breadcrumb: true
    },
    children: [{
      path: '/changePasswordIndex',
      name: 'changePassword',
      component: () => import('@/views/changePassword/index'),
      meta: {
        title: 'menu.changePassword',
        icon: 'el-icon-document',
        breadcrumb: true
      }
    }]
  },
  {
    path: '/homeDefault',
    name: 'home_welcome',
    component: layoutComponent,
    meta: {
      // title: 'menu.home',
      icon: 'el-icon-document',
      breadcrumb: true
    },
    children: [{
      path: 'welcome',
      name: 'welcome',
      component: () => import('@/views/homes/welcome'),
      meta: {
        title: 'menu.home',
        icon: 'el-icon-document',
        breadcrumb: true
      }
    }]
  }
]
